import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentIqService {
  constructor(private appService: AppService) {}

  /** 检查payment iq 是否已打开 */
  isPidOpened: boolean = false;

  get limitPiqCurrencies(): string[] {
    return JSON.parse(this.appService.tenantConfig.config?.limitPiqCurrency || '[]');
  }

  /**
   * 当用户选择CNY VND THB，但是打开了PIQ 弹出弹窗并且重新选择货币
   *
   * @param currency 选择货币
   * @returns
   */
  onCurrencyCheck(currency: string): boolean {
    if (this.limitPiqCurrencies.includes(currency)) return false;
    return true;
  }
}
